import styled from '@emotion/styled';

const Card = styled.div`
  padding: 1rem;
  border: 1px solid var(--color-gray-3);
  border-radius: 0.25rem;
  background-color: #fff;
`;
export default Card;
